<template>
  <transition
    enter-active-class="transition ease-out duration-300"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition ease-in duration-200"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-if="isVisible" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-200 p-4">
      <transition
        enter-active-class="transition ease-out duration-300"
        enter-from-class="opacity-0 scale-95 translate-y-4"
        enter-to-class="opacity-100 scale-100 translate-y-0"
        leave-active-class="transition ease-in duration-200"
        leave-from-class="opacity-100 scale-100 translate-y-0"
        leave-to-class="opacity-0 scale-95 translate-y-4"
      >
        <div v-if="isVisible" class="bg-white rounded-lg shadow-2xl max-w-md w-full mx-auto overflow-hidden">
          <!-- Icon Header -->
          <div class="bg-primary-100 px-6 pt-8 pb-6">
            <div class="mx-auto w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center shadow-lg">
              <div class="w-16 h-16 bg-primary-500 rounded-full flex items-center justify-center">
                <font-awesome-icon :icon="['fas','question']" class="text-white text-2xl animate-pulse"/>
              </div>
            </div>
          </div>

          <!-- Content -->
          <div class="px-8 py-6">
            <h3 class="text-xl font-semibold text-gray-900 text-center mb-2">Confirm Action</h3>
            <p class="text-gray-600 text-center leading-relaxed">{{ message }}</p>
          </div>

          <!-- Actions -->
          <div class="px-8 pb-8 flex gap-3">
            <button
              class="flex-1 bg-red-dark hover:bg-red-700 text-white font-medium py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:shadow-xl"
              @click="confirm"
            >
              <font-awesome-icon :icon="['fas','check']" class="mr-2"/>
              Yes, I'm sure
            </button>
            <button
              class="flex-1 bg-white hover:bg-gray-50 text-gray-700 font-medium py-3 px-6 rounded-lg border-2 border-gray-200 hover:border-gray-300 transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]"
              @click="cancel"
            >
              <font-awesome-icon :icon="['fas','times']" class="mr-2"/>
              Cancel
            </button>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestion, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

library.add(faQuestion, faCheck, faTimes);

export default {
  components: {FontAwesomeIcon},
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      default: 'Are you sure you want to proceed with this action?'
    }
  },
  emits: ['confirm', 'cancel'],
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
@reference "../../assets/theme.css";
/* Add smooth transitions for all interactive elements */
button {
  @apply transition-all duration-200;
}

/* Optional: Add a subtle animation to the icon */
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}
</style>
